import { customElement, property } from 'lit/decorators.js';
import { html, TemplateResult } from 'lit';
import { OnlineReservationBase } from './online-reservation-base.js';
import { closeNativeDialog, executeOnOriginPage } from '@mobile-app/native-dialog';
import arrowBackIcon from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-16_arrow-left.svg?element';
import { addPresentationToIcon } from '../icon/icon-accessibility.js';

@customElement('ents-online-reservation-app-layer')
export class OnlineReservationAppLayer extends OnlineReservationBase {
  @property({ type: String, attribute: 'data-variant-id' })
  variantId = '';

  connectedCallback() {
    super.connectedCallback();

    this.loadConfigFromDOM();

    if (typeof executeOnOriginPage === 'function') {
      executeOnOriginPage(`
        document.dispatchEvent(new CustomEvent('ents:online-reservation-native-opened', {bubbles: true, composed: true}));
      `);
    }

    // Automatically load model when component connects
    if (this.variantId) {
      this.loadModel(this.variantId);
      this.appState = this.appState.nextStep();
    }
  }

  private loadConfigFromDOM() {
    const configElement = this.querySelector('#ents-or-config');
    if (configElement?.textContent) {
      try {
        const config = JSON.parse(configElement.textContent);
        this.config = config;
        this.messages = config.messages || {};
      } catch (e) {
        console.error('Failed to parse config:', e);
      }
    }
  }

  render(): TemplateResult {
    return html`
      <div class="ents-or-app-layer" style="padding: 20px 0;">
        ${this.renderAppLayerBackButton()}
        <div class="ents-or-app-layer__content" style="padding: 0 16px;">${this.renderContent()}</div>
      </div>
    `;
  }

  private renderAppLayerBackButton() {
    const showBackButton = this.appState.currentStep > 0 && this.appState.currentStep < 4;

    if (!showBackButton) {
      // Return empty spacer to maintain layout consistency
      return html` <div style="height: 40px;"></div>`;
    }

    return html`
      <div style="padding: 0 16px; margin-bottom: 16px;">
        <a
          class="bdk-link-secondary"
          size="medium"
          href="#"
          aria-label="${this.messages['back']}"
          @click="${this.handleBackNavigation}"
        >
          <div style="display: inline-block; margin-right: 8px;">${addPresentationToIcon(arrowBackIcon())}</div>
          ${this.messages['back']}
        </a>
      </div>
    `;
  }

  // Override renderBackButton to return empty since we handle it differently
  // eslint-disable-next-line class-methods-use-this
  protected renderBackButton() {
    return html``;
  }

  // eslint-disable-next-line class-methods-use-this
  handleClose(): void {
    if (typeof closeNativeDialog === 'function') {
      closeNativeDialog();
    }
  }

  handleSuccessfulReservation(): void {
    this.appState = this.appState.setReservationStatus(true);

    try {
      if (typeof executeOnOriginPage === 'function') {
        const trackingData = this.getTrackingData();
        executeOnOriginPage(`
          (function() {
            if (!window.CubeDataLayer) {
              window.CubeDataLayer = [];
            }
            window.CubeDataLayer.push(${JSON.stringify(trackingData)});
          })();
        `);
      }
    } catch (error) {
      console.error('Failed to execute tracking:', error);
    }

    this.appState = this.appState.nextStep();
  }
}
